import { isCampaignEnabled } from '../../jsCore/config/campaignConfig'
import { external as externalScriptLoader } from '../../jsCore/utils/script'
import { externalScriptsConfig } from '../../jsCore/organizedByType/config/externalScripts'
import { register } from '../../components/viewability/viewbilityTracker'
import { getCountryCode } from '../../jsCore/providers/geolocationProvider'

const FRESH_EIGHT_CONFIG_CLIENTE = {
  whiteListCountryCodes: ['MX'],
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: ['sponsored'],
}

const FRESH_EIGHT_CONFIG_LADBROKES = {
  whiteListCountryCodes: ['GB'],
  pageTypes: ['post'],
  isEmbedded: false,
  daysWhiteList: [0, 1, 2, 3, 4, 5, 6],
  isSlideshow: false,
  featureId: 'Fresh8',
  blacklistedCategories: [],
}

var freshEightCampaigns = [FRESH_EIGHT_CONFIG_CLIENTE]
function addPlaceHolder() {
  let paragraph = document.querySelectorAll('.post-content > p')[2]
  if (paragraph !== undefined && paragraph !== null) {
    paragraph.insertAdjacentHTML(
      'afterEnd',
      '<div class="freshEightPlaceHolder" data-viewability_category="Article page" data-viewability_action="widget viewable impression" ' +
        'data-viewability_label="fresh8"><div id="f8-2"></div><div id="f8-1"></div></div>'
    )
  }
}

function getScript() {
  return getCountryCode().then(response => {
    if (response === 'MX') {
      return { src: externalScriptsConfig.freshEightMX.src, name: 'freshEightMX' }
    } else if (response === 'GB') {
      return { src: externalScriptsConfig.freshEightGB.src, name: 'freshEightGB' }
    }
  })
}

function injectScript() {
  return getScript().then(response => {
    externalScriptLoader.load({
      config: {
        src: response.src,
        name: response.name,
      },
      loadNow: true,
    })
  })
}

export function injectFreshEight() {
  freshEightCampaigns.forEach(campaign => {
    isCampaignEnabled(campaign).then(response => {
      if (response.isCampaignEnabled) {
        addPlaceHolder()
        injectScript()
        register('.freshEightPlaceHolder')
      }
    })
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fresh8/freshEightInjector.js